import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { PraticaSection } from '../../pratica/models/pratica-section';
import { PraticaStats } from '../../pratica/models/pratica-stats';
import { PraticaProgressService } from '../services/pratica-progress.service';

export const PraticaGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  let outcomePaths = Object.values(PraticaStats) as string[];
  let detailPath =
    state.root.firstChild?.firstChild?.firstChild?.firstChild?.routeConfig
      ?.path;

  let outcomePath =
    state.root.firstChild?.firstChild?.firstChild?.routeConfig?.path;
  let router = inject(Router);

  let idPratica = route.paramMap.get('idPratica');
  if (!idPratica) {
    return router.createUrlTree(['home', 'requests']);
  }
  let praticaProgressService = inject(PraticaProgressService);
  return praticaProgressService.getPratica(idPratica).pipe(
    map((pratica) => {
      if (
        (detailPath === PraticaSection.SCORE &&
          praticaProgressService.scoreDisabled) ||
        (detailPath === PraticaSection.PRESENTATION_SHEET &&
          praticaProgressService.presentationSheetDisabled) ||
        (outcomePath &&
          outcomePaths.includes(outcomePath) &&
          (!praticaProgressService.isOutcome ||
            praticaProgressService.isBackOfficeChannelInOutcome))
      ) {
        return router.createUrlTree(['pratica', idPratica]);
      } else return true;
    })
  );
};
